@if (
  {
    newsLoading: newsLoading$ | async,
    newsLoadingMore: newsLoadingMore$ | async,
    loadingError: loadingError$ | async,
    news: news$ | async,
  };
  as newsStreamsObj
) {
  <h4 class="font-bold">News</h4>
  @if (!newsStreamsObj.newsLoading) {
    @if (!newsStreamsObj.loadingError) {
      @for (news of newsStreamsObj.news; track trackById($index, news)) {
        <news-list-element-outlet
          [news]="news"
          [ngClass]="{ 'preview-news': news.Id === previewNewsId }"
        ></news-list-element-outlet>
      }
      <div
        [hidden]="!newsStreamsObj.newsLoadingMore"
        class="more-loader flex flex-center-start w-full h-full"
        data-test-id="news-list-more-loader"
      >
        <loader color="primary"></loader>
      </div>
    } @else {
      <div class="flex flex-center-start w-full h-full">
        <no-data data-test-id="news-list-no-data"></no-data>
      </div>
    }
  } @else {
    <div class="flex flex-center-start w-full h-full">
      <loader class="init-loader" color="primary" data-test-id="news-list-init-loader"></loader>
    </div>
  }
}
